import {
  css,
  mq,
  spacing,
  styled,
  Text,
  zIndex,
  ZIndexLevel,
} from '@thg-commerce/enterprise-theme'
import { Button, ErrorMessage, SafeHtml } from '@thg-commerce/gravity-elements'

export const StyledLi = styled.li<{ lastItem?: boolean }>`
  margin-top: 0;
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  ${(props) => !props.lastItem && `border-bottom: none;`}
`

export const StyledMenuTitle = styled.h2`
  ${Text('medium1', 'alternate')}
  margin: ${spacing(5)} 0 ${spacing(4)} 0;
`

export const BuildYourOwnBundleContainer = styled.div`
  margin: 0 auto;
  max-width: ${(props) => props.theme.site.siteWidth};
  position: relative;
  padding: 0 ${spacing(1)};
  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: 0 ${spacing(3)};
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    padding: 0 ${spacing(4)};
  }
`

export const StyledTotalTitle = styled.h2`
  ${Text('medium1', 'alternate')}
  margin-bottom:${spacing(3)};
`

export const TitleContainer = styled.div`
  width: 100%;
  margin-bottom: ${spacing(5)};
  padding: 0 ${spacing(1)};
`

export const Title = styled(SafeHtml)`
  ${Text('xlarge1', 'default')}
  word-break: break-word;
  margin-bottom: ${spacing(2)};
`

export const Subtitle = styled(SafeHtml)`
  width: 100%;
`

export const StyledHiddenCircularProgress = styled.div`
  position: absolute;
  width: 200px;
  height: 200px;
  transform: rotate(45deg);
  top: 150px;
  background-color: ${(props) => props.theme.colors.palette.greys.white};
`

export const StyledTotalSummary = styled(SafeHtml)`
  ${Text('bodyText', 'alternate')};
  text-align: center;
`
export const SummaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-bottom: ${spacing(5)};
`

export const StyledLeftMenu = styled.div`
  display: none;
  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    display: flex;
    flex-direction: column;
    padding-bottom: ${spacing(8)};
    width: 300px;
    margin-right: ${spacing(4)};
    position: sticky;
    top: 150px;
    height: 100%;
  }
`

const activeLiStyle = css`
  background-color: ${(props) => props.theme.colors.palette.brand.lightest};
  &:before {
    content: '';
    width: 4px;
    height: 100%;
    display: inline-block;
    left: 0;
    top: 0;
    position: absolute;
    background-color: ${(props) => props.theme.colors.palette.brand.base};
  }
`

export const StyledButton = styled.button<{ active?: boolean }>`
  ${Text('bodyText', 'default')};
  position: relative;
  transition: background-color 0.3s ease;
  padding: ${spacing(1.5)} ${spacing(2)};
  width: 100%;
  text-align: left;
  &:hover {
    background-color: ${(props) => props.theme.colors.palette.brand.lightest};
  }
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(1.5)} ${spacing(2)};
    ${(props) => props.active && activeLiStyle}
  }
`

export const Bar = styled.div<{ completedRatio: number }>`
  height: 100%;
  width: ${(props) => props.completedRatio}%;
  background-color: ${(props) => props.theme.colors.palette.brand.base};
  transition: 0.3s ease;
  border-radius: 8px;
`

export const StyledProgressBar = styled.div`
  width: 100%;
  height: 14px;
  margin: auto 0;
  border-radius: 8px;
  background-color: ${(props) => props.theme.colors.palette.greys.grey};
`

export const ProgressBarContainer = styled.div`
  width: 100%;
  display: flex;
  gap: ${spacing(1)};
  margin: 0 ${spacing(2)} ${spacing(1)} 0;
  position: relative;
  flex-direction: column;
`

export const BarWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 82px;
  border-top: 1px solid ${(props) => props.theme.colors.palette.greys.light};

  ${zIndex(ZIndexLevel.Base)}

  background-color: ${(props) => props.theme.colors.palette.greys.white};
  box-sizing: border-box;
  padding: ${spacing(2)} ${spacing(2)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: ${spacing(2)} ${spacing(4)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    display: none;
  }
  display: flex;
  flex-direction: row;
  justify-content: center;
`

export const CircularCurrentIndicator = styled.span`
  position: absolute;
  ${Text('xlarge2', 'alternate')};
  top: 70px;
`

export const StyledCircularProgress = styled.div<{ progress: number }>`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: conic-gradient(
    ${(props) => props.theme.colors.palette.brand.base},
    ${(props) => props.progress}deg,
    #ededed 0deg
  );
  transform: rotate(228deg);
  &::before {
    content: '';
    position: absolute;
    height: 75%;
    width: 75%;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.palette.greys.white};
  }
`

export const CircularProgressContainer = styled.div`
  width: 250px;
  height: 230px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${spacing(2.5)} ${spacing(2.5)} 0 ${spacing(2.5)};
  overflow: hidden;
  position: relative;
`

export const CircularWrapper = styled.div`
  width: 250px;
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  position: relative;
`

export const BundlePriceWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const BundlePriceText = styled.span`
  ${Text('large1', 'alternate')};

  margin-bottom: ${spacing(1)};
`

export const BundlePrice = styled.span`
  ${Text('large1', 'default')};
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${spacing(2)};
`

export const AddToBasketButton = styled(Button)<{
  isCircularBar?: boolean
}>`
  width: 120px;
  ${(props) =>
    props.isCircularBar &&
    `
     margin: 0 auto ${spacing(2)};
  `}
  button,
  button:hover,
  button:focus,
  button:disabled,
  button:active {
    padding-left: ${spacing(0.5)};
    padding-right: ${spacing(0.5)};
  }
`

export const TotalReceiptBox = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: ${spacing(2)};
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
`

export const TotalContent = styled.div`
  width: 100%;
  margin-top: ${spacing(1)};
  text-align: center;
`

export const TotalContentText = styled.span`
  ${Text('small', 'default')};
`

export const ProgressBarTotalContentText = styled.span`
  ${Text('small', 'alternate')};
`

export const AddToBasketErrorMessage = styled(ErrorMessage)`
  margin-bottom: ${spacing(4)};
`

export const TotalContentPrice = styled.h2`
  ${Text('medium1', 'default')};
  margin-top: ${spacing(1)};
  margin-bottom: ${spacing(2)};
`

export const AddTotalToBasket = styled(Button)`
  width: 100%;
  button,
  button:hover,
  button:focus,
  button:disabled,
  button:active {
    padding-left: ${spacing(0.5)};
    padding-right: ${spacing(0.5)};
  }
`
